// Dependencies
import React from 'react';
import radium from 'radium';
import { connect } from 'react-redux';
import { ThemeContext } from '../../../components/theme/Theme.jsx'

// Styles
import './Pricelevel.scss';
import LeoLabel from "../../../components/form/LeoLabel.tsx";
import LeoSelect from "../../../components/form/LeoReactSelect.tsx";

interface PricelevelProps {
	amountOfTickets: number,
	onChange: any,
	pricelevel?: any,
	selectedAmount?: any,
	ticketsAvailable?: any,
	totalPrice?: any
}

export const defaultProps = {
	amountOfTickets: 0,
	selectedAmount: 0
}

function Pricelevel(propsIn: PricelevelProps) {
	const props = {...defaultProps, ...propsIn};
	const context = React.useContext(ThemeContext);
	const style = {
		priceLevel: {
			margin: context.themeManager.value('event-price-level-item', 'margin'),
		},
		ticketPrice: {
			color: context.themeManager.value('event-ticket-price', 'color'),
			fontWeight: context.themeManager.value('event-ticket-price', 'fontWeight'),
		},
	};
	const amountOfTicketsConfig = context.themeManager.getIntOrNullFromTheme('pricelevel', 'amount-of-tickets', null) || 10;

	const numberOfTicketDropdownOptions = Math.min(amountOfTicketsConfig, parseInt(props.ticketsAvailable, 10));
	const options = [{value: '0' ,label:'Anzahl', isSelected: props.amountOfTickets === 0}];
	for (let i = 1; i <= numberOfTicketDropdownOptions; i++) {
		options.push({
			value: i.toString(),
			label: i.toString(),
			isSelected: i === props.amountOfTickets,
		});
	}

	return props.pricelevel ?
		(
			<div className="pricelevel__item" style={style.priceLevel}>
				<div className="pricelevel__name">
					{props.pricelevel.name}
					{props.pricelevel.forSponsors ? " ★" : ""}
				</div>
				<div className="pricelevel__value">
					je {parseFloat(props.pricelevel.price.value)
					.toFixed(2)} €
				</div>
				
				<div className="pricelevel__amount">
					<LeoLabel className={"visually-hidden"} id={'pl_label_' + props.pricelevel.priceLevelUuid} for={'pl_' + props.pricelevel.priceLevelUuid} label={`Anzahl Tickets Preisstufe ${props.pricelevel.name}`}/>
					<LeoSelect
						placeholder={"Anzahl"}
						id={'pl_' + props.pricelevel.priceLevelUuid}
						className="dropdown"
						onChange={(event:any) => props.onChange(event, props.pricelevel.priceLevelUuid)}
						value={props.amountOfTickets}
						name={`Anzahl Tickets Preisstufe ${props.pricelevel.name}`}
						options={options}
						centerText={true}
						smallDropdown={true}
					>
					</LeoSelect>
				</div>
				<div className="pricelevel__price--total" style={style.ticketPrice}>
					{parseFloat(props.totalPrice)
						.toFixed(2)} €
				</div>
			</div>
		) : null;
}
const RadiumPricelevel = radium(Pricelevel);


// ------------------------------
// Store Connection
// ------------------------------
const mapStateToProps = (_state:any, ownProps:any) => {
	const amountOfTickets = ownProps.selectedAmount || 0;
	return {
		categoryUuid: ownProps.categoryUuid,
		pricelevel: ownProps.pricelevel,
		totalPrice: amountOfTickets * ownProps.pricelevel.price.value,
		amountOfTickets,
	};
};

export default connect(
	mapStateToProps,
)(RadiumPricelevel);
